import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Input } from "reactstrap";
import axios from "axios";

import { withTranslation } from "react-i18next";

const CulturePicker = ({ t, allowNone, className, id, onChange, size }) => {
  const [cultures, setCultures] = useState([]);
  const [currentCulture, setCurrentCulture] = useState(0);

  useEffect(() => {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    load(source);
    return () => {
      source.cancel("Cancel");
    };
  }, []);

  const load = async (source) => {
    try {
      const res = await axios({
        url: `api/user/culture`,
        cancelToken: source.token,
        method: "GET",
      });
      console.log(res);
      setCultures(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      <Input
        type="select"
        bsSize={size || "md"}
        value={id}
        onChange={onChange}
        className={className || ""}
      >
        {(id === 0 || allowNone) && (
          <option value={0}>{t("CulturePicker.chooseCulture")}</option>
        )}
        {cultures.map((culture) => (
          <option key={culture.culture} value={culture.culture}>
            {culture.description}
          </option>
        ))}
      </Input>
    </div>
  );
};

CulturePicker.propTypes = {
  allowNone: PropTypes.bool,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  onChange: PropTypes.func,
  size: PropTypes.string,
  t: PropTypes.func,
};

export default withTranslation()(CulturePicker);
